import { ReactElement } from 'react'
import NotAllowed from './NotAllowed'
import UserService from '../../services/UserService'

interface Props {
  roles: string[]
  children: ReactElement
}

const RenderOnRole = ({ roles, children }: Props) =>
 roles.length == 0  || UserService.hasRole(roles) ? children : <NotAllowed />;

export default RenderOnRole
